module.exports = require('./src/validate');


//////////////////
// WEBPACK FOOTER
// ./node_modules/password-validator-minimalist/index.js
// module id = WkoI
// module chunks = 0